import type from './constants';

export default {
    updateDoctor: (params) => {
        return {
            type: type.UPDATE_DOCTOR,
            params,
        }
    },
    saveSearchParams: (params) => {
        return {
            type: type.SAVE_SEARCH_PARAMS,
            params,
        }
    },
};


// WEBPACK FOOTER //
// ./src/components/hospital/doctorInfo/store/actions.js